import Swal from "sweetalert2";
import i18next from "i18next";

export const showErrorAlert = ({ ...params }, didClose) => {
  Swal.fire({
    icon: "error",
    confirmButtonText: i18next.t("swal.btn.confirm"),
    confirmButtonColor: "#2287B8",
    didClose,
    customClass: {
      popup: 'custom-swal-popup'
    },
    ...params,
  });
};

export const ErrorSession = (callback = () => {}) => {
  showErrorAlert(
    {
      title: i18next.t("error.session.title"),
      text: i18next.t("error.session.text"),
    },
    callback
  );
};

export const ErrorTimeExceeded = (callback = () => {}) => {
  showErrorAlert(
    {
      title: i18next.t("error.authentication.title"),
      text: i18next.t("error.authentication.text"),
    },
    callback
  );
};

export const ErrorConnection = (callback = () => {}) => {
  showErrorAlert(
    {
      title: i18next.t("error.connection.title"),
      text: i18next.t("error.connection.text"),
    },
    callback
  );
};

export const Error500 = (callback = () => {}) => {
  showErrorAlert(
    {
      title: i18next.t("error.500.title"),
      text: i18next.t("error.500.text"),
    },
    callback
  );
};

export const ErrorTransaction = (callback = () => {}) => {
  showErrorAlert(
    {
      title: i18next.t("error.transaction.title"),
      text: i18next.t("error.transaction.text"),
    },
    callback
  );
};

export const ShowError = (callback = () => {}, title, text) => {
  showErrorAlert(
    {
      title: title,
      text: text,
    },
    callback
  );
};
